import PropTypes from 'prop-types'
import { MenuItem, Select } from '@mui/material'
import { KeyboardArrowDown } from '@mui/icons-material'

import { getLanguageOptions } from './helpers'
import { useTranslation } from 'react-i18next'

const LanguageSelect = ({ value, onChange }) => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)
  const items = getLanguageOptions({ t })

  return (
    <div className="Search-page__filters-language-wrapper">
      <span>{t.global.language}</span>
      <Select
        className="Search-page__filters-language"
        value={value}
        IconComponent={KeyboardArrowDown}
        MenuProps={{ className: 'Search-page__filters-language-menu' }}
        onChange={onChange}
      >
        {items.map(({ value, label }, index) => {
          const lastClass = index + 1 === items.length ? 'last' : ''

          return (
            <MenuItem
              key={index}
              className={`Search-page__filters-menu-item ${lastClass}`}
              value={value}
            >
              {label}
            </MenuItem>
          )
        })}
      </Select>
    </div>
  )
}

LanguageSelect.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

export default LanguageSelect
